import { useCallback } from "react";

import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

import {
    getAllCustomerSupportRequests,
    setResetCustomerSupportRequests,
    useFastshiftDispatch,
    useFastshiftSelector
} from "../../../state";

export const useCustomerSupportRequests = () => {
    const dispatch = useFastshiftDispatch();
    const stargateClient = useBxpWebStargateClient();

    const { data, pending, error } = useFastshiftSelector(
        (state) => state.customerSupportRequests
    );

    const getCustomerSupportRequests = useCallback(() => {
        dispatch(getAllCustomerSupportRequests(stargateClient));
    }, [dispatch, stargateClient]);

    const retry = useCallback(() => {
        dispatch(setResetCustomerSupportRequests());
        dispatch(getAllCustomerSupportRequests(stargateClient));
    }, [dispatch, stargateClient]);

    return {
        data,
        pending,
        error,
        retry,
        getCustomerSupportRequests
    };
};
